import { TaskGrid } from "../../components/TaskGrid/TaskGrid";
import ViewTitle from "../../layout/components/ViewTitle";
import { useParams } from "react-router-dom";

export const CustomView = () => {
  const { viewId } = useParams();
  /* Avoid having state/queries here because it can cause performance issues with the grid */
  return (
    <>
      <div>
        <ViewTitle viewId={viewId} allowRenaming />
      </div>
      <div className="row">
        <TaskGrid enableSaveView={true} viewId={viewId} />
      </div>
    </>
  );
};
